import React from 'react';
import './../Apps.css';
import DragDrop from './../DragDrop';

const FishCounting = ({name}) => {
    return (
        <DragDrop appName = {name} />
    );
};

export default FishCounting;